import React from "react";
import Footer from "components/footer/Footer";
import Header from "components/header/Header";
import UserHeroSection from "components/user/UserHeroSection";
import UserAuth from "components/AuthGaurd/UserAuth";
import AddPet from "./AddPet";

export default function AddPetForm() {
  return (
    <UserAuth>
      <header>
        <Header />
      </header>
      <UserHeroSection title={"Add User Pet"}>
        <AddPet />
      </UserHeroSection>
      <footer className="tw-block">
        <Footer />
      </footer>
    </UserAuth>
  );
}
